import { Injectable, Injector } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from 'rxjs';
import { SidebarNavMenuService } from "../../../rms/app/shared/core-rms/sidebar-nav-menu.service";
import { NdmsResolverService } from "../interfaces/ndmsResolverService";

@Injectable()
export class LeftNavResolverGuard implements Resolve<any> {
    constructor(private injector: Injector, private menuService: SidebarNavMenuService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any | Observable<any[]> | Promise<any[]> {
        let service: NdmsResolverService = this.injector.get(route.data.service);
        return service.resolve(this.menuService.links$.toPromise());
    }
}